import React, { useContext, useEffect, useState } from 'react';
// import './ProfilePopUp.css'; 
import { ERROR_MESSAGES } from '../../Componant/GlobalMessages';
import { LoaderContext, AuthContext } from '../../Context/ContextProvider';
import {
  get_employer_profile,
  update_employer_profile,
} from '../Services/EmployerDashboardApi';
import { get_list_filter_signup } from '../../Services/Student/StudentApi';
import SuccessModel from '../../Componant/SuccessModel';
import ImageUploadEditModal from '../Componant/ImageUploadEditModal'; 
import ConfirmationModal from '../../Componant/ConfirmationModal';
import editIcon from '../../Assets/Images/editIcon.png';
import ViewImagePopup from '../../Componant/ViewImage';

const ProfileAndSettingPopUp = ({ isOpen, onClose, Tab }) => {
  const [activeTab, setActiveTab] = useState(Tab || 'profile');
  const [requireMessage, setRequireMessage] = useState(false);
  const [Error, setError] = useState('');
  const [isAddUpdateDone, setAddUpdateDone] = useState(false);
  const [isImagePopupOpen, setIsImagePopupOpen] = useState(false);
  const [IsViewImage, setIsViewImage] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [image, setImage] = useState(null);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const { setLoader } = useContext(LoaderContext);
  const { authDetails, isProfileUpdate, setIsProfileUpdate } = useContext(AuthContext);

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const [profileData, setProfileData] = useState({
    name: null,
    email: null,
    location: null,
    website: null,
    description: null,
    thumbnail: '',
    header_pic: '',
  });
  const [allLocations, setAllLocations] = useState([]);
  const [matchedLocations, setMatchedLocations] = useState([]);
  const [activeLocationIndex, setActiveLocationIndex] = useState(null);
  const [highlightedLocationIndex, setHighlightedLocationIndex] = useState(-1);

  const handleLocationSearch = (value, index) => {
    setActiveLocationIndex(index);
    setHighlightedLocationIndex(-1);
    if (!value || !value.trim()) {
      setMatchedLocations([]);
      return;
    }
    const searchTerm = value.toLowerCase().replace(/\s+/g, ' ').trim();
    const filtered = allLocations
      .filter(loc => {
        const label = loc.label.toLowerCase().replace(/\s+/g, ' ').trim();
        return label.includes(searchTerm);
      })
      .slice(0, 50);
    setMatchedLocations(filtered);
  };

  const selectLocation = loc => {
    setProfileData(prev => ({ ...prev, location: loc.label }));
    setMatchedLocations([]);
    setActiveLocationIndex(null);
  };
  const isKnownLocationLabel = value => {
    const normalizedValue = (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    return !!normalizedValue && allLocations.some(loc => loc.label.toLowerCase().replace(/\s+/g, ' ').trim() === normalizedValue);
  };
  const handleLocationBlur = () => {
    setTimeout(() => {
      setMatchedLocations([]);
      setActiveLocationIndex(null);
      if (profileData.location && !isKnownLocationLabel(profileData.location)) {
        setProfileData(prev => ({ ...prev, location: '' }));
      }
    }, 200);
  };

  const handleLocationKeyDown = e => {
    if (matchedLocations.length === 0) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setHighlightedLocationIndex(prev => (prev < matchedLocations.length - 1 ? prev + 1 : prev));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setHighlightedLocationIndex(prev => (prev > 0 ? prev - 1 : prev));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (highlightedLocationIndex >= 0 && highlightedLocationIndex < matchedLocations.length) {
        selectLocation(matchedLocations[highlightedLocationIndex]);
      }
    }
  };

  useEffect(() => {
    if (isOpen) {
      setActiveTab(Tab || 'profile');
    }
  }, [isOpen, Tab]);

  useEffect(() => {
    const fetchFiltersData = async () => {
      try {
        const response = await get_list_filter_signup();
        const locations = [];
        const processItem = item => {
          if (item.name && item.code) {
            locations.push({ label: `${item.name} (${item.code})`, value: item.code });
            (item.cities || []).forEach(city => {
              locations.push({ label: `${city}, ${item.code}`, value: `${city}, ${item.code}` });
            });
          }
        };
        if (response && response.us_state_city) {
          response.us_state_city.forEach(item => {
            if (item.states) item.states.forEach(state => processItem(state));
            else processItem(item);
          });
        } else if (Array.isArray(response)) {
          response.forEach(item => processItem(item));
        } else if (response && Array.isArray(response.data)) {
          response.data.forEach(item => processItem(item));
        }
        setAllLocations(locations);
      } catch (error) {
        console.error('Failed to fetch location filters:', error);
      }
    };

    fetchFiltersData();
  }, []);

  useEffect(() => {
    handleGetEmployerDetails();
    setAddUpdateDone(false);
  }, [isOpen, isAddUpdateDone]);

  const handleGetEmployerDetails = async () => {
    setLoader(true);
    try {
      const response = await get_employer_profile();
      if (!response?.code?.includes('ERR')) {
        setLoader(false);
        const profile = response.profile || {};
        setProfileData(prev => ({
          ...prev,
          name: profile.name,
          email: profile.email,
          location: profile.location,
          website: profile.website,
          description: profile.description,
          thumbnail: profile.logo, // Mapping logo to thumbnail for consistent UI use
          header_pic: profile.header_pic,
        }));
      } else {
        setLoader(false);
        setError(response?.response?.data?.error);
      }
    } catch (err) {
      setLoader(false);
      setError('Something went wrong. Please try again.');
    }
  };

  if (!isOpen) return null;

  const handleTabClick = tab => {
    setActiveTab(tab);
    setError('');
  };

  const handleProfileChange = e => {
    const { name, value } = e.target;
    setProfileData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    if (
      !profileData.name ||
      !profileData.email 
    ) {
      setRequireMessage(true);
      return;
    }
    setLoader(true);
    const data = await update_employer_profile({
      name: profileData.name,
      email: profileData.email,
      location: profileData.location,
      website: profileData.website,
      description: profileData.description,
    });

    if (!data?.code?.includes('ERR')) {
      setLoader(false);
      setIsSuccessOpen(true);
    } else {
      setLoader(false);
      setError(data?.response?.data?.message || 'Something went wrong. Please try again.');
    }
  };

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
          padding: '0px',
        }}
        onClick={onClose}
      />
      <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
          zIndex: 1001,
          maxWidth: '500px',
          width: '90%',
          maxHeight: '90vh',
          overflowY: 'auto'
        }}
        onClick={e => e.stopPropagation()}
      >
        <div className="container2">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
            <h4 style={{ margin: 0, fontWeight: 600, fontSize: '20px' }}>Profile & Settings</h4>
            <button
              onClick={onClose}
              style={{
                background: 'transparent',
                border: 'none',
                fontSize: '28px',
                cursor: 'pointer',
                color: '#555',
                padding: '0',
                lineHeight: '1',
              }}
            >
              &times;
            </button>
          </div>
          <div className="profileBtn-groupPropfile" style={{ marginTop: '10px' }}>
            <button className={`profileBtn ${activeTab === 'profile' ? 'active' : ''}`} onClick={() => handleTabClick('profile')}>
              Profile
            </button>
            <button className={`profileBtn ${activeTab === 'settings' ? 'active' : ''}`} onClick={() => handleTabClick('settings')}>
              Settings
            </button>
          </div>

          <div id="parent">
            {activeTab === 'profile' && (
              <div className="box a active" style={{ margin: '-16px' }}>
                <div className="profile-header">
                  <div
                    style={{
                      position: 'relative',
                      display: 'inline-block',
                      marginBottom: '15px',
                    }}
                  >
                    <img
                      onClick={() => {
                        setImage(profileData.thumbnail);
                        setIsViewImage(true);
                      }}
                      src={`${profileData.thumbnail}?t=${Date.now()}`}
                      alt="Profile"
                      className="profile-img"
                      style={{
                        width: '85px',
                        height: '85px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                      }}
                    />
                    <span
                      className="profile-edit-icon"
                      onClick={() => {
                        setImage(profileData.thumbnail);
                        setIsImagePopupOpen(true);
                        setIsViewImage(false);
                      }}
                    >
                      <img src={editIcon} alt="edit"></img>
                    </span>
                  </div>
                  <div className="profile-info">
                    <h2>{profileData.name}</h2>
                    <p className="university">{profileData.email}</p>
                    <p className="university">{profileData.location}</p>
                  </div>
                </div>
                <div className="profile-form">
                  {[
                    { label: 'Company Name', name: 'name' },
                    { label: 'Email Address', name: 'email' },
                    { label: 'Website', name: 'website' },
                    { label: 'Location', name: 'location' },
                  ].map((field, index) => (
                    <div key={index}>
                      <div className="form-group">
                        <label>{field.label}</label>
                      </div>
                      <div
                        className="form-field"
                        style={{
                          display: 'flex',
                          width: '100%',
                          flexDirection: 'row',
                          position: field.name === 'location' ? 'relative' : undefined,
                        }}
                      >
                        <input
                          type="text"
                          name={field.name}
                          placeholder={`Enter ${field.label}`}
                          value={profileData[field.name] || ''}
                          onBlur={field.name === 'location' ? handleLocationBlur : undefined}
                          onKeyDown={field.name === 'location' ? handleLocationKeyDown : undefined}
                          onChange={e => {
                            if (field.name === 'location') {
                              const val = e.target.value.replace(/[0-9]/g, '');
                              handleProfileChange({ target: { name: 'location', value: val } });
                              handleLocationSearch(val, 'mainProfile');
                              return;
                            }
                            handleProfileChange(e);
                          }}
                          style={{
                            width: '100%',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            padding: '8px',
                            height: '38px',
                          }}
                        />
                        {field.name === 'location' && activeLocationIndex === 'mainProfile' && matchedLocations.length > 0 && (
                          <div
                            className="location-dropdown shadow-sm"
                            onMouseDown={event => event.stopPropagation()}
                            onClick={event => event.stopPropagation()}
                            style={{
                              position: 'absolute',
                              top: '100%',
                              left: 0,
                              right: 0,
                              backgroundColor: '#fff',
                              border: '1px solid #ccc',
                              borderRadius: '4px',
                              maxHeight: '200px',
                              overflowY: 'auto',
                              zIndex: 1050,
                            }}
                          >
                            {matchedLocations.map((loc, idx) => (
                              <div
                                key={`${loc.label}-${idx}`}
                                className="location-dropdown-item text-dark"
                                style={{
                                  padding: '8px 12px',
                                  cursor: 'pointer',
                                  backgroundColor: highlightedLocationIndex === idx ? '#f5f5f5' : 'transparent',
                                }}
                                onMouseDown={event => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  selectLocation(loc);
                                }}
                                onClick={event => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                }}
                              >
                                {loc.label}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      {requireMessage && !profileData[field.name] && field.name !== 'website' && (
                          <span className="validation">{ERROR_MESSAGES}</span>
                        )}
                    </div>
                  ))}
                  
                   <div className="form-group">
                        <label>Description</label>
                   </div>
                   <div className="form-field">
                        <textarea
                            name="description"
                            placeholder="Enter Company Description"
                            value={profileData.description || ''}
                            onChange={handleProfileChange}
                            style={{
                              width: '100%',
                              border: '1px solid #ccc',
                              borderRadius: '4px',
                              padding: '8px',
                              minHeight: '80px',
                            }}
                          />
                   </div>

                  <div className="button-group" style={{ width: '70%' }}>
                    <button type="button" className="profileBtn cancel" onClick={() => onClose(false)}>
                      Close
                    </button>
                    <button type="button" className="profileBtn save" onClick={handleSave}>
                      <i className="fa-solid fa-floppy-disk"></i> Save Changes
                    </button>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'settings' && (
              <div className="box b active">
                {/* Settings Content Placeholder - simplified for Employer for now */}
                <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                  <p>Settings are currently limited for this view.</p>
                  <button
                    onClick={() => {
                        window.open('/privacy-policy', '_blank');
                    }}
                    className="profileBtn"
                    style={{marginTop: '10px'}}
                    >
                    View Privacy Policy
                    </button>
                  <button
                    onClick={() => {
                        window.open('/terms-of-service', '_blank');
                    }}
                    className="profileBtn"
                    style={{marginTop: '10px'}}
                    >
                    View Terms of Service
                    </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <SuccessModel
          isOpen={isSuccessOpen}
          title="Success!"
          message={successMessage || (activeTab === 'profile' ? 'Profile updated successfully!' : 'Settings updated successfully!')}
          buttonText="OK"
          onClose={() => {
            handleGetEmployerDetails();
            setSuccessMessage('');
            setIsSuccessOpen(false);
            setIsProfileUpdate(true);
            onClose();
          }}
        />
        {isImagePopupOpen && (
          <ImageUploadEditModal
            image={image}
            onClose={() => setIsImagePopupOpen(false)}
            isAddUpdateDone={isAddUpdateDone}
            setAddUpdateDone={setAddUpdateDone}
            Type={'Profile'}
          />
        )}
        {IsViewImage && <ViewImagePopup image={image} onClose={() => setIsViewImage(false)} />}
        <ConfirmationModal
          isOpen={isConfirmOpen}
          title="Alert!"
          message="Are you sure?"
          confirmText="Yes"
          action="Delete"
          onCancel={() => setIsConfirmOpen(false)}
        />
      </div>
    </>
  );
};

export default ProfileAndSettingPopUp;
